import script from "./LtInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./LtInfo.vue?vue&type=script&setup=true&lang=js"

import "./LtInfo.vue?vue&type=style&index=0&id=40d0f202&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40d0f202"]])

export default __exports__